import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { isNull } from 'lodash-es'

import { WebinarTopbarComponent } from '../..'
import {
  getIsDraft,
  isBroadcastLive,
  isBroadcastStreaming,
  getLiveButtonState,
  getEndButtonState,
  isGoLiveButtonDisabled,
  isHeadlessInSession,
} from '../../../selectors'
import {
  redirectToManagePage as redirectToManagePageAction,
  onLiveToggle as onLiveToggleAction,
  toggleEndWebinarConfirmVisibility as toggleEndWebinarConfirmVisibilityAction,
} from '../../../actions'

import Counters from './Counters'

const Toolbar = ({
  /**
   * Connected properties
   */
  isDraft,
  isBroadcasting,
  isStreaming,
  role,
  liveTogglingTriggeredAt,
  liveData,
  streamingStartFailed,
  isEndWebinarConfirmModalVisible,
  liveButtonState,
  endButtonState,
  webinarEnded,
  isEndingWebinar,
  isInGearMode,
  isLiveButtonDisabled,
  isHeadlessPresent,

  /**
   * Connected functions
   */
  redirectToManagePage,
  onLiveToggle,
  toggleEndWebinarConfirmVisibility,
}) => (
  <WebinarTopbarComponent
    role={role}
    isBroadcasting={isBroadcasting}
    isStreaming={isStreaming}
    isEndingWebinar={isEndingWebinar}
    onLiveToggle={onLiveToggle}
    liveStatus={liveData.live_status}
    isDraft={isDraft}
    togglingInProgress={!isNull(liveTogglingTriggeredAt)}
    showEndWebinarConfirmModal={() => toggleEndWebinarConfirmVisibility(true)}
    streamingStartFailed={streamingStartFailed}
    hideEndWebinarConfirmModal={() => toggleEndWebinarConfirmVisibility(false)}
    isEndWebinarConfirmModalVisible={isEndWebinarConfirmModalVisible}
    liveButtonState={liveButtonState}
    endButtonState={endButtonState}
    webinarEnded={webinarEnded}
    redirectToManagePage={redirectToManagePage}
    isInGearMode={isInGearMode}
    isLiveButtonDisabled={isLiveButtonDisabled}
    isHeadlessPresent={isHeadlessPresent}
    isTemplate={!!liveData.template_p}
  >
    <Counters />
  </WebinarTopbarComponent>
)

Toolbar.propTypes = {
  /**
   * Connected properties
   */
  isDraft: PropTypes.bool,
  isBroadcasting: PropTypes.bool,
  isStreaming: PropTypes.bool,
  role: PropTypes.oneOf(['presenter', 'producer']),
  liveTogglingTriggeredAt: PropTypes.object,
  liveData: PropTypes.object,
  streamingStartFailed: PropTypes.bool,
  isEndWebinarConfirmModalVisible: PropTypes.bool,
  liveButtonState: PropTypes.oneOf(['idle', 'loading']),
  endButtonState: PropTypes.oneOf(['idle', 'loading']),
  webinarEnded: PropTypes.bool,
  isEndingWebinar: PropTypes.bool,
  isInGearMode: PropTypes.bool,
  isLiveButtonDisabled: PropTypes.bool,
  isHeadlessPresent: PropTypes.bool,

  /**
   * Connected functions
   */
  redirectToManagePage: PropTypes.func,
  onLiveToggle: PropTypes.func,
  toggleEndWebinarConfirmVisibility: PropTypes.func,
}

const mapStateToProps = (state) => ({
  /**
   * Connected properties
   */
  isDraft: getIsDraft(state),
  isBroadcasting: isBroadcastLive(state),
  isStreaming: isBroadcastStreaming(state),
  role: state.webinar.role,
  liveTogglingTriggeredAt: state.webinar.liveTogglingTriggeredAt,
  liveData: state.webinar.liveData,
  streamingStartFailed: state.webinar.streamingStartFailed,
  isEndWebinarConfirmModalVisible:
    state.webinar.isEndWebinarConfirmModalVisible,
  liveButtonState: getLiveButtonState(state),
  endButtonState: getEndButtonState(state),
  webinarEnded: state.webinar.webinarEnded,
  isEndingWebinar: state.webinar.isEndingWebinar,
  isInGearMode: state.webinar.isGearMode,
  isLiveButtonDisabled: isGoLiveButtonDisabled(state),
  isHeadlessPresent: isHeadlessInSession(state),
})

const mapDispatchToProps = {
  /**
   * Connected functions
   */
  redirectToManagePage: redirectToManagePageAction,
  onLiveToggle: onLiveToggleAction,
  toggleEndWebinarConfirmVisibility: toggleEndWebinarConfirmVisibilityAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(Toolbar)
